import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';
import common from '@common';
import datastore from '@datastore';
import { getActiveDimensions } from '@shared/active_resize_listener/selectors';

const {
  utils: {
    departments: { getUserDepartments },
    dimension: { DIMENSION_STATES },
    roles: { USER_ROLES },
  },
} = common;

const { company: companySelectors, getSummaryCounts } = datastore.selectors;

export const getLoading = state => state.app.loading;
export const getLoadingLoader = state => state.app.loadingLoader;
export const getAuthenticated = state => state.app.authenticated;
export const getCurrentUser = state => state.app.user;
export const getCurrentCompanyUser = state => state.app.user.company_person;
export const getAuthError = state => state.app.authError;
export const getForgotPasswordStatus = state => state.app.forgotPassword;
export const getMobileHeaderVisibility = state =>
  state.internalStore.appConfig.mobileHeaderVisibility;
export const getMobileMenuVisibility = state => state.internalStore.appConfig.mobileMenuVisibility;
export const getMaintenanceMode = state => state.internalStore.appConfig.maintenanceMode;
export const getPasswordTokenValidationStatus = state => state.app.passwordTokenValidation;
export const getPasswordResetStatus = state => state.app.passwordReset;
export const getUserRegister = state => state.app.userRegister;
export const getUserRegisterLoading = state => state.app.userRegisterLoading;
export const getSmsVerified = state => state.app.user.sms_verified;
export const getUserEmail = state => state.app.user.email;
export const getUserTimezoneOffset = state => {
  const timeZoneOffset = _.get(state.app.user, 'type_timezone.offset') || moment().format('Z');
  const formatedTimeZone = _.split(timeZoneOffset, ':');
  formatedTimeZone[1] *= 0.6;
  return parseFloat(_.replace(formatedTimeZone, ',', '.'));
};

export const getUserTimezoneName = state => _.get(state.app.user, 'type_timezone.name');

export const getCurrentUserIsAdmin = createSelector(
  [getCurrentUser],
  user => {
    const role = _.get(user, 'company_person.type_role.code', '');
    return role === USER_ROLES.ADMINISTRATOR;
  },
);

export const getCurrentUserIsAdminOrSupervisior = createSelector(
  [getCurrentUser],
  user => {
    const role = _.get(user, 'company_person.type_role.code', '');
    return role === USER_ROLES.ADMINISTRATOR || role === USER_ROLES.SUPERVISOR;
  },
);

export const getCurrentUserRole = createSelector(
  [getCurrentUser],
  user => _.get(user, 'company_person.type_role.code'),
);

export const getCurrentUserDepartments = createSelector(
  getCurrentCompanyUser,
  companyUser => companyUser && companyUser.type_departments.map(department => department.code),
);

export const getCurrentUserAccessItems = createSelector(
  getCurrentCompanyUser,
  companyUser => (companyUser && companyUser.access_items) || [],
);

export const getUserNotificationOptions = state =>
  (getCurrentUser(state) && getCurrentUser(state).notification_options) || [];

export const isMobile = createSelector(
  getActiveDimensions,
  activeDimensions => _.isEqual(activeDimensions.state, DIMENSION_STATES.MOBILE),
);

export const getNavigationConfig = createSelector(
  companySelectors.isMessageFeatureEnabled,
  companySelectors.isServicePartner,
  companySelectors.getMessageFeature,
  companySelectors.getNavigationDisplaySetting,
  companySelectors.getPropertyFeature,
  getSummaryCounts,
  companySelectors.getSuppliesEnabled,
  getCurrentUserRole,
  getCurrentUserAccessItems,
  companySelectors.isPropertyReadinessOld,
  (
    canSeeMessageFeature,
    isServicePartner,
    messageFeature,
    navigationDisplaySetting,
    propertyFeature,
    summaryCounts,
    suppliesEnabled,
    typeRole,
    userAccess,
    isPropertyReadinessOld,
  ) => {
    const userDepartments = getUserDepartments(userAccess);

    return [
      typeRole,
      {
        canSeeMessageFeature,
        isPropertyReadinessOld,
        isServicePartner,
        messageFeature,
        navigationDisplaySetting,
        propertyFeature,
        suppliesEnabled,
        userDepartments,
      },
    ];
  },
);
